import { constant, noop } from '@sgme/fp';
import type { CellClickedEvent, ColDef } from 'ag-grid-community';
import { useCallback } from 'react';

export function useOnCellClickHandler<Item>(
  onSetActiveItem: (item?: Item) => void = noop,
  canSetActive: (selectedColDef: ColDef | null) => boolean = constant(false),
) {
  return useCallback(
    (event: CellClickedEvent<Item>) => {
      const selectedRows: Item[] = event.api.getSelectedRows();
      const selectedCell = event.api.getFocusedCell();
      const selectedCellColDef = selectedCell?.column?.getUserProvidedColDef() ?? null;
      if (canSetActive(selectedCellColDef)) {
        onSetActiveItem(selectedRows[0]);
      }
    },
    [onSetActiveItem, canSetActive],
  );
}
